import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicTable,
  CardComponent,
  // OverviewCardWithIcon,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
// import componentConstants from '../../../core-utils/messages/componentConstants';
import EmptyTable from '../../atoms/EmptyTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
// import { getInfoIcon } from '../../../core-utils/helper-utils/infoIconHelper';

export interface PatientDetailsOverviewTabProps {
  adherenceValues: any[];
  activeMedications: any[];
  // rafScoreValues: string[][];
  // polyPharmaInteractionValues: string[][];
}

const PatientDetailsOverviewTab: React.FC<PatientDetailsOverviewTabProps> = ({
  adherenceValues,
  activeMedications,
  // rafScoreValues,
  // polyPharmaInteractionValues,
}) => {
  const useStyles = makeStyles()({
    overviewCardWithIconCardGridItem: {
      marginRight: '32px',
    },
    flexOverviewCards: {
      marginRight: '32px',
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
    },
  });

  const { classes } = useStyles();

  // const moleculeConstants =
  //   componentConstants.MOLECULES.PATIENT_DETAILS_OVERVIEW_TAB;

  // const tootlipStyles = {
  //   fontFamily: 'Inter',
  //   fontStyle: 'normal',
  //   fontWeight: 400,
  //   fontSize: '12px',
  //   lineHeight: '160%',
  //   maxWidth: '300px',
  // };

  const cellStyles = {
    color: patientAccessTheme.palette.text.mediumemphasis,
    fontSize: '12px',
    fontWeight: 500,
  };
  const columnsForTables: any[] = [
    {
      name: 'Medication',
      align: 'left',
      cellStyles: cellStyles,
      width: '200px',
    },
    {
      name: 'Adherence',
      align: 'right',
      cellStyles: cellStyles,
      width: '',
    },
    // {
    //   name: 'Year',
    //   align: 'right',
    //   cellStyles: cellStyles,
    //   width: '',
    // },
  ];
  const medicationColumns: any[] = [
    {
      name: 'Medication',
      align: 'left',
      cellStyles: cellStyles,
      width: '150px',
    },
    {
      name: 'Fill Date',
      align: 'left',
      cellStyles: cellStyles,
      width: '220px',
    },
    {
      name: 'Theraputic class',
      align: 'left',
      cellStyles: cellStyles,
      width: '',
    },
  ];

  return (
    <Grid container>
      <Grid container style={{ margin: '34px 30px' }}>
        <Grid className={classes.overviewCardWithIconCardGridItem}>
          <CardComponent
            title="Medication Adherence"
            subTitle="List of medications"
            body={
              <>
                {adherenceValues?.length > 0 ? (
                  <BasicTable
                    columns={columnsForTables}
                    rowsData={adherenceValues}
                    cellHeight="43px"
                    tableHeight="259px"
                    width="358px"
                    handleHeaderMouseEnter={() => {}}
                    handleHeaderMouseLeave={() => {}}
                    handleOnClick={() => {}}
                  />
                ) : (
                  <EmptyTable text={'NO DATA'} width="300px" />
                )}
              </>
            }
          />
        </Grid>
        <Grid>
          <CardComponent
            title="Active medications"
            subTitle="List of active medications"
            body={
              <>
                {activeMedications?.length > 0 ? (
                  <BasicTable
                    columns={medicationColumns}
                    rowsData={activeMedications}
                    cellHeight="43px"
                    tableHeight="259px"
                    width="370px"
                    handleHeaderMouseEnter={() => {}}
                    handleHeaderMouseLeave={() => {}}
                    handleOnClick={() => {}}
                  />
                ) : (
                  <EmptyTable text={'NO DATA'} width="300px" />
                )}
              </>
            }
          />
        </Grid>
        {/* <Grid item className={classes.flexOverviewCards}> */}
        {/* <OverviewCardWithIcon
            title={moleculeConstants.RAF_SCORE}
            values={rafScoreValues}
            toolTipContent={moleculeConstants.RAF_SCORE_TOOLTIP}
            toolTipStyles={{ ...tootlipStyles, textAlign: 'justify' }}
          /> */}
        {/* <OverviewCardWithIcon
            title={moleculeConstants.POLY_PHARMA_INTERACTION}
            values={polyPharmaInteractionValues}
            toolTipContent={
              <div
                dangerouslySetInnerHTML={{
                  __html: moleculeConstants.POLY_PHARMA_INTERACTION_TOOLTIP,
                }}
              />
            }
            toolTipStyles={{
              ...tootlipStyles,
              whiteSpace: 'pre-line',
              textAlign: 'justify',
            }}
          /> */}
        {/* </Grid> */}
      </Grid>
      {/* <Grid item style={{ marginLeft: '34px' }}>
        <RecommendActionsAccordion
          recommendedActions={[
            {
              icon: (
                <Timelinefile
                  stroke={patientAccessTheme.palette.primary[500]}
                  style={{
                    width: '16px',
                    height: '16px',
                    marginInlineStart: '35px',
                  }}
                />
              ),
              title: moleculeConstants.MEDICAL_MANAGEMENT_REFER,
              subTitle: moleculeConstants.MEDICAL_MANAGEMENT_PORTAL,
            },
            {
              icon: (
                <Timelinefile
                  stroke={patientAccessTheme.palette.primary[500]}
                  style={{
                    width: '16px',
                    height: '16px',
                    marginInlineStart: '35px',
                  }}
                />
              ),
              title: moleculeConstants.CASE_MANAGEMENT_REFER,
              subTitle: moleculeConstants.CASE_MANAGEMENT_PORTAL,
            },
          ]}
        />
      </Grid> */}
    </Grid>
  );
};

export default PatientDetailsOverviewTab;
